import { render, staticRenderFns } from "./netbank-login-qr.pug?vue&type=template&id=64f6de4e&lang=pug&external"
import script from "./netbank-login-qr.js?vue&type=script&lang=js&external"
export * from "./netbank-login-qr.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports